/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:14:26 
 * @Last Modified by: pcjser
 * @Last Modified time: 2018-06-11 11:45:19
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/base.scss';
import App from './App';
import { loginStatus } from './service/fetch';
import { platformSet, equipmentSet } from './service/utils';

//锋玩登录
window.fengwanLogin = function (token) {
  window.localStorage.setItem('fw-token', token)
  window.webkit.messageHandlers.FW_reload.postMessage(null)
}

equipmentSet('fw-equipment')
platformSet('fw-platform', plat => {
  if (plat === 'fengwanI') {
    window.document.getElementsByTagName('body')[0].classList.add("fengwan")
    ReactDOM.render(<App />, document.getElementById('root'))
  } else {
    loginStatus().then(res => {
      // console.info('进来了》》2');
      if (res.code === 200) {
        window.localStorage.setItem('fw-username', res.payload.username)
      } else {
        window.localStorage.removeItem('fw-username')
      }
      ReactDOM.render(<App />, document.getElementById('root'))
    })
  }
})

window.localAlipayResult = data => {
  if (typeof data === "string") {
    data = JSON.parse(data)
  }
  if (data.ResultStatus * 1 === 9000) {
    const channel = "锋玩app"
    window.location.replace(`${window.location.origin}/fengwan/#/result/${channel}`)
    // window.location.href = `${window.location.origin}/fengwan/#/result/${channel}`
  } else {
    window.webkit.messageHandlers.FW_log.postMessage("支付未完成")
  }
}

window.localWechatResult = data => {
  if (data * 1 === 0) { //0表示支付成功
    const channel = "锋玩app"
    window.location.replace(`${window.location.origin}/fengwan/#/result/${channel}`)
    // window.location.href = `${window.location.origin}/fengwan/#/result/${channel}`
  } else {
    window.webkit.messageHandlers.FW_log.postMessage("支付未完成")
  }
}



// WEBPACK FOOTER //
// ./src/index.jsx